import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../../button/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { __ } from "../../i18n/src";
import { Dropdown } from './Dropdown';
const ellipsisIcon = () => (_jsx(FontAwesomeIcon, { height: "18px", iconName: "ellipsis", iconType: CATEGORIES.SOLID }));
export const DropdownThreeDotsButton = (_a) => {
    var { screenReadersText = __('Open dropdown'), variant = 'secondary' } = _a, props = __rest(_a, ["screenReadersText", "variant"]);
    return (_jsx(Dropdown, Object.assign({}, props, { children: _jsx(Button, Object.assign({ icon: ellipsisIcon, isDisabled: props.isDisabled, screenReadersText: screenReadersText, type: null, variant: variant }, (!props.isDisabled && { as: 'span' }))) })));
};
//# sourceMappingURL=DropdownThreeDotsButton.js.map